import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { arrayRemove } from 'redux-form/immutable';

// components
import { Field } from 'redux-form/immutable';

class Holiday extends React.Component {
  static propTypes = {
    day:        PropTypes.number,
    disableDay: PropTypes.bool,
    form:       PropTypes.string,
    hasError:   PropTypes.bool,
    month:      PropTypes.number,
    name:       PropTypes.string.isRequired,
    onDelete:   PropTypes.func,
    position:   PropTypes.number
  }

  render() {
    const { disableDay } = this.props;

    return (
      <div className='holiday'>
        <button className={ classNames('form__reject holiday__delete') }
          onClick={ this._handleDelete }>
          <i className='fa fa-times' />
        </button>
        <Field className='form__select holiday__month'
          component='select'
          name='month'>
          <option />
          { this._renderMonths() }
        </Field>
        <Field className='form__select holiday__day'
          component='select'
          disabled={ disableDay }
          name='day'>
          <option />
          { this._renderDays() }
        </Field>
        { this._renderError() }
      </div>
    );
  }

  // private

  _handleDelete = this._handleDelete.bind(this);

  _handleDelete(e) {
    e.preventDefault();

    const { dispatch, form, name, position } = this.props;

    dispatch(arrayRemove(form, name, position));
  }

  _renderDays() {
    const options = [];
    const { month } = this.props;

    if (month) {
      const daysInMonth = moment(`2000-${month}`, 'YYYY-MM').daysInMonth();

      for (let i = 0; i < daysInMonth; i++) {
        const day = i + 1;

        options.push(
          <option key={ i } value={ day }>{ day }</option>
        );
      }
    }

    return options;
  }

  _renderError() {
    let component;

    if (this.props.hasError) {
      component = <i className='fa fa-exclamation-circle holiday__error' />;
    }

    return component;
  }

  _renderMonths() {
    const months  = moment.months();
    const options = [];

    for (let i = 0; i < months.length; i++) {
      options.push(<option key={ i } value={ i + 1 }>{ months[i] }</option>);
    }

    return options;
  }
}

export default connect()(Holiday);



// WEBPACK FOOTER //
// ./app/components/managers/_Holiday.jsx